/**
 * Propriedade pedrão
 */
export class DefaultProp {
    /** ID da entidade no Firebase  */
    uuid: string;

    /** Nome */
    name: string;

    /**
     * Instanciar um
     * @param init - JSON que represente parcialmente as propriedades da classe
     */
    public constructor(init?: Partial<DefaultProp>) {
        Object.assign(this, init);
    }

    /**
     *
     */
    toFirebase(): object {
        if (this.name && this.name !== '') {
            return {
                name: this.name,
                uuid: this.uuid,
            };
        } else {
            return null;
        }
    }
}
